import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import WorkspaceRail from '../WorkspaceRail/WorkspaceRail';
import Navbar from '../Navbar/Navbar';
import styles from './AppLayout.module.css';

// Shell for authenticated pages: Discord-style workspace rail on the left,
// then a column with the top bar + routed content.
// On mobile the rail collapses to an off-canvas drawer triggered by the
// hamburger button in the Navbar.
export default function AppLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className={styles.shell}>
      {drawerOpen && (
        <div
          className={styles.scrim}
          aria-hidden="true"
          onClick={() => setDrawerOpen(false)}
        />
      )}
      <WorkspaceRail drawerOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <div className={styles.body}>
        <Navbar onMenuOpen={() => setDrawerOpen(true)} />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
